import { isString } from 'lodash-es'
import { forwardRef } from 'react'
import type { PickersTextFieldProps as MuiPickersTextFieldProps } from '@mui/x-date-pickers-pro'
import * as $ from './PickersTextField.styled'
import type { PickersTextFieldStyledProps } from './PickersTextField.styled'

export interface PickersTextFieldProps extends Omit<MuiPickersTextFieldProps, 'error'>, PickersTextFieldStyledProps {
  'data-testid'?: string
  error?: string | boolean
}

/**
 * The design-system date field. Use as the `textField` slot of any MUI X picker/field
 * (it is the `MuiDesktopDatePicker` default). Mirrors `TextField`'s `error` (string sets
 * the helper text), `warning`, and `data-testid`-from-`id` conventions on the v9
 * section-based field. Plain `TextField` cannot be used as a picker slot in v9 — it has
 * an `<input>` instead of a `PickersSectionList`.
 */
export const PickersTextField = forwardRef<HTMLDivElement, PickersTextFieldProps>(
  ({ id, warning, error, helperText, size = 'medium', ...props }, ref) => (
    <$.PickersTextField
      id={id}
      data-testid={id}
      size={size}
      error={Boolean(error)}
      helperText={isString(error) ? error : helperText}
      {...(warning && { 'data-warning': true, warning })}
      {...props}
      ref={ref}
    />
  ),
)

PickersTextField.displayName = 'PickersTextField'
